var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9951 28.0998L21.9902 19.0576",
    stroke: "#0688FA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3349 28.0998L26.3398 19.0576",
    stroke: "#0688FA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6063 31.3179H17.7275",
    stroke: "#0688FA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8636 35.1818C15.9974 35.1818 17.7272 33.452 17.7272 31.3182C17.7272 29.1844 15.9974 27.4546 13.8636 27.4546C11.7298 27.4546 10 29.1844 10 31.3182C10 33.452 11.7298 35.1818 13.8636 35.1818Z",
    stroke: "#0688FA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4681 35.1818C36.6019 35.1818 38.3317 33.452 38.3317 31.3182C38.3317 29.1844 36.6019 27.4546 34.4681 27.4546C32.3343 27.4546 30.6045 29.1844 30.6045 31.3182C30.6045 33.452 32.3343 35.1818 34.4681 35.1818Z",
    stroke: "#0688FA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1644 19.7272C26.2982 19.7272 28.028 17.9974 28.028 15.8636C28.028 13.7298 26.2982 12 24.1644 12C22.0306 12 20.3008 13.7298 20.3008 15.8636C20.3008 17.9974 22.0306 19.7272 24.1644 19.7272Z",
    stroke: "#0688FA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle);
export default __webpack_public_path__ + "static/media/triangle.723a323d5eb175acd7972552548b1fea.svg";
export { ForwardRef as ReactComponent };